import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPageWidth } from "../../features/pageWidth/pageWidthSlice";

/**
 * Custom hook to handle window size changes and dispatch the new width
 * to the Redux store. It listens for resize events on the window and
 * updates the page width accordingly.
 *
 * Usage:
 * This hook should be called within a React component to keep track of
 * the current window width and update the Redux store whenever the
 * window is resized.
 */
export const useWindowSize = () =>
{
    const dispatch = useDispatch();

    const handleWindowSizeChange = () =>
    {
        dispatch( setPageWidth( window.innerWidth ) );
    };

    useEffect( () =>
    {
        window.addEventListener( "resize", handleWindowSizeChange );
        return () =>
        {
            window.removeEventListener( "resize", handleWindowSizeChange );
        };
    }, [ dispatch ] );
};
